// bind_Modal
import bind_modal from '@/components/AreaBind';

// msg_Modal
import msg_modal from '@/components/MsgModal';

// comfirm_Modal
import comfirm_modal from '@/components/ComfirmWarn';

// copy_Modal
import copy_modal from '@/components/CopyModal';

// cutDetail_Modal
import cutDetail_modal from '@/components/CutDetail';

// order_Modal
import order_modal from '@/components/OrderDetail';

// rule_modal
import rule_modal from '@/components/RuleModal';

// buy_modal
import buy_modal from '@/components/BuyModal';

// help_modal
import help_modal from '@/components/HelpModal';

// sale_detail
import sale_detail from '@/components/SaleDetailModal';

// record_modal
import record_modal from '@/components/RecordShop';

// score_modal
import score_modal from '@/components/RecordScore';

// ticket_modal
import ticket_modal from '@/components/OfferModal';

// welcome_modal
import welcome_modal from '@/components/WelcomeModal';

// w12_rule
import w12_rule from '@/components/w12/RuleModal';

// w12_comfirm
import w12_comfirm from '@/components/w12/ComfirmWarn';

// w12_copy
import w12_copy from '@/components/w12/CopyModal';

// invite_apply
import invite_apply from '@/components/w12/InviteApply';

// success_apply
import success_apply from '@/components/w12/SuccessModal';

let utils = {
    $bind_modal : bind_modal,
    $msg_modal : msg_modal,
    $comfirm_modal : comfirm_modal,
    $copy_modal : copy_modal,
    $cutDetail_modal : cutDetail_modal,
    $buy_modal : buy_modal,
    $sale_detail : sale_detail,
    $rule_modal : rule_modal,
    $record_modal : record_modal,
    $score_modal : score_modal,
    $ticket_modal : ticket_modal,
    $welcome_modal : welcome_modal,
    $order_modal : order_modal,
    $help_modal : help_modal,
    $w12_rule : w12_rule,
    $w12_comfirm : w12_comfirm,
    $w12_copy : w12_copy,
    $invite_apply : invite_apply,
    $success_apply : success_apply,
}

export default utils;